export const SCORE_THRESHOLD = 0.5;

export const RECAPTCHA_ERROR_MESSAGE =
  'We were unable to verify your request. Please refresh the page and try again.';

export const RECAPTCHA_SHORT_ERROR_MESSAGE = 'Captcha verification failed';
